module.exports = __webpack_public_path__ + "img/14.d3f43a33.jpg";